var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImagesBig = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 60,
  x: 25,
  y: 30,
  stroke: "currentColor",
  strokeWidth: 3,
  rx: 4
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 50,
  r: 8,
  fill: "currentColor",
  opacity: 0.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m25 75 20-20 20 20 20-20 10 10v25H25z",
  opacity: 0.3
})));
export default SvgImagesBig;